import React from "react";
import { Formik } from "formik";
import { withStyles, Button, Typography, FormGroup, FormControlLabel, Checkbox, CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import { isSuperUser } from "../../../sc-utilities";
import { ThemeProvider } from '@material-ui/styles';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { createMuiTheme } from '@material-ui/core';
import {getDateFormat} from "../../../sc-utilities/date";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        width: "120px",
        marginTop: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    buttons: {
        textAlign: 'right'
    }
});

const defaultMaterialThemeAdmin = createMuiTheme({
    palette: {
        primary: { 500: '#0C5A99' }
    }
});

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: { 500: '#7dc5e2' }
    }
});

const DeliveryNoteForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, setFieldValue, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <ThemeProvider theme={isSuperUser() ? defaultMaterialThemeAdmin : defaultMaterialTheme}>
                                <KeyboardDatePicker
                                    name={'DateFrom'}
                                    label={translations['from_last_delivery_note'] || 'Date from last delivery note'}
                                    onBlur={handleBlur}
                                    clearable={true}
                                    error={!!(errors.DateFrom && touched.DateFrom && errors.DateFrom)}
                                    onChange={(date) =>
                                        setFieldValue("DateFrom", date)
                                    }
                                    value={values.DateFrom}
                                    margin={"dense"}
                                    onAccept={date => setFieldValue("DateFrom", date)}
                                    fullWidth={true}
                                    format={getDateFormat()}
                                />
                                <KeyboardDatePicker
                                    clearable={true}
                                    name={'DateTo'}
                                    label={translations['date_to_charge_customer'] || 'Please select till which day you want to charge customer'}
                                    onBlur={handleBlur}
                                    error={!!(errors.DateTo && touched.DateTo && errors.DateTo)}
                                    onChange={(date) =>
                                        setFieldValue("DateTo", date)
                                    }
                                    value={values.DateTo}
                                    margin={"dense"}
                                    onAccept={date => setFieldValue("DateTo", date)}
                                    fullWidth={true}
                                    format={getDateFormat()}
                                />
                            </ThemeProvider>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            margin={"dense"}
                                            name={"Billed"}
                                            checked={values.Billed}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={translations['you_charged_customer'] || 'Did you charged customer for this delivery note? (check for yes)'}
                                />
                            </FormGroup>
                            <div className={classes.buttons}>
                                {formSettings.ButtonCancel ? (

                                    <Button
                                        className={classes.cancel}
                                        variant="contained"
                                        color={formSettings.ButtonCancel.Color}
                                        onClick={formSettings.ButtonCancel.handleCancel}
                                        disabled={loading}
                                    >
                                        {formSettings.ButtonCancel.Title}
                                    </Button>
                                ) : null
                                }
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        disabled={loading || !(isValid && dirty) || isSubmitting}
                                    >
                                        {loading || isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(DeliveryNoteForm);
